import { useNavigation } from "@react-navigation/native"
import { StackNavigationProp } from "@react-navigation/stack"
import {
  Caption,
  H4,
  Subtitle1,
  ThemeProvider,
  useTheme,
  WelcomeButton,
  WelcomeScreen,
} from "capsule"
import _ from "lodash"
import React, { useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next"

import { welcomeImages } from "../../assets/images"
import { NavigationNS } from "../i18n/constants"
import { OnboardingParamList, RootParamList } from "./types"

const MyWelcomeScreen = () => {
  const navigation = useNavigation<
    | StackNavigationProp<OnboardingParamList, "RegisterActivationCode">
    | StackNavigationProp<RootParamList, "Login">
  >()

  const {
    colors: {
      surface: { background },
      black: { highEmphasis },
      primary,
      white: { highEmphasis: white },
    },
    dimensions: { spacing, marginSides },
  } = useTheme()

  const s = useMemo(
    () => ({
      image: {
        marginTop: marginSides,
        marginBottom: spacing / 2,
      },
    }),
    [marginSides, spacing],
  )

  const { t } = useTranslation()

  const onSubmitWelcome = useCallback(
    async (button: WelcomeButton) => {
      if (button === "signUp") {
        ;(navigation as StackNavigationProp<RootParamList, "Login">).navigate("Login")
      } else {
        ;(
          navigation as StackNavigationProp<OnboardingParamList, "RegisterActivationCode">
        ).navigate("RegisterActivationCode")
      }
    },
    [navigation],
  )

  return (
    <ThemeProvider
      customTheme={{
        colors: { surface: { background } },
      }}
    >
      <WelcomeScreen
        buttonStyles={[
          {
            color: white,
          },
          {
            color: primary,
          },
        ]}
        pages={_.map(_.range(0, 3), i => ({
          // @ts-ignore false positive
          image: welcomeImages[i],
          ...t(`${NavigationNS}:Welcome:welcome.${i}`, { returnObjects: true }),
        }))}
        onSubmit={(button: WelcomeButton) => onSubmitWelcome(button)}
        TitleComponent={H4}
        // @ts-ignore
        transComponents={{ p: <Caption /> }}
        DescriptionComponent={Subtitle1}
        imageStyle={s.image}
        hideStatusBar={false}
        showHtmlView
        color={{ color: highEmphasis }}
      />
    </ThemeProvider>
  )
}

export default MyWelcomeScreen
